export const BASE_ASSIGNMENT_CONTRACT_FILE = {
  NO_FILE: 'noFile.pdf',
};
